export default __webpack_public_path__ + "static/media/sensotrend_uploader_login2.d225648d.png";